import React from 'react';
import classNames from 'classnames';
import { HeaderFooterBase } from '../../HeaderFooterBase';
import '../scss/Header.scss';

const Header = ({
    children,
    className,
    ...otherProps
}) => (
    <HeaderFooterBase
        className={classNames('ccdHeader', className)}
        variant="Header"
        {...otherProps}>
        {children}
    </HeaderFooterBase>
);

export default Header;
